/**
 * A kind of treatment room and how many of them the clinic has -- "Sala masaj", 2 -- with the
 * disciplines (catalogue type ids) that need one. Never a physical room: no appointment is
 * assigned one. The API refuses a booking, and offers no slot, wherever a room's disciplines
 * already fill every room of its kind. Only an administrator ever reads these.
 */
export interface IRoom {
    id: number;
    name: string;
    capacity: number;
    catalogTypeIds: number[];
}

/** A room in full, for both creating and editing one. */
export interface IRoomRequest {
    name: string;
    capacity: number;
    catalogTypeIds: number[];
}

/** The capacity stays a string while it is being typed, as every number in a form does. */
export interface RoomFormValues {
    name: string;
    capacity: string;
    catalogTypeIds: number[];
}

export const toRoomFormValues = (room: IRoom | null): RoomFormValues => room
    ? { name: room.name, capacity: String(room.capacity), catalogTypeIds: room.catalogTypeIds }
    : { name: '', capacity: '1', catalogTypeIds: [] };

export const toRoomRequest = (values: RoomFormValues): IRoomRequest => ({
    name: values.name.trim(),
    capacity: Number(values.capacity),
    catalogTypeIds: values.catalogTypeIds,
});
